import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-roll-right",
  "use": "icon-roll-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-roll-right\">\r\n<path d=\"M750.6,561.8c-132,127.6-264,255.2-396,382.7c-54.3,52.6-135.4-32.8-80.8-85.5c117.5-113.6,234.9-227,352.3-340.6\r\n\tC508.1,400.8,390.1,283.3,272,165.8c-53.7-53.5,27.3-138.9,80.8-85.5C485.4,212.3,618,344.2,750.6,476.2\r\n\tC772.5,498.1,773,540.1,750.6,561.8L750.6,561.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol